import React, { useEffect, useState } from 'react'
import logo from "../assets/image/learningportal.svg"
import { Link } from 'react-router-dom'
import { useLoginMutation } from '../features/auth/authApi';
import swal from 'sweetalert';


export default function Login({role}) {
    const [login, { isSuccess: isSuccessLogin, isError: isErrorLogin, error: loginError }] = useLoginMutation()

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")


    useEffect(() => {
        if (isSuccessLogin) {
            swal("Successful", "Login successful", "success")
            setEmail("")
            setPassword("")
        }

        if (isErrorLogin) {
            swal("Error", loginError?.data, "error")
        }

    }, [isSuccessLogin, isErrorLogin, loginError])

    function handleSubmit(e) {
        e.preventDefault();
        if (email && password) {
            login({ email, password })
        }
    }

    return (
        <section className="py-6 bg-primary h-screen grid place-items-center">
            <div className="mx-auto max-w-md px-5 lg:px-0">

                <div>
                    <Link to="/home"><img className="h-12 mx-auto" src={logo} alt='logo' /></Link>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                        Sign in to {role} Account
                    </h2>
                </div>
                <form onSubmit={handleSubmit} className="mt-8 space-y-6" action="#" method="POST">
                    <input type="hidden" name="remember" value="true" />
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label for="email-address" className="sr-only">Email address</label>
                            <input id="email-address" name="email" type="email" autocomplete="email" value={email} onChange={e => setEmail(e.target.value)} required
                                className="login-input rounded-t-md" placeholder="Email address" />
                        </div>
                        <div>
                            <label for="password" className="sr-only">Password</label>
                            <input id="password" name="password" type="password" autocomplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required
                                className="login-input" placeholder="Password" />
                        </div>
                    </div>

                    <div className="flex items-center justify-end">
                        <div className="text-sm">
                            {
                                role === "Student" && <Link to="/student-registration" className="font-medium text-violet-600 hover:text-violet-500">
                                    Create New Account
                                </Link>
                            }

                        </div>
                    </div>

                    <div>
                        <button type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                            Sign in
                        </button>
                    </div>
                </form>
            </div>
        </section>
    )
}
